import { Object3D } from 'three';

export const xy_axes_plane_name = 'xy_axes_plane';
export const yz_axes_plane_name = 'yz_axes_plane';
export const xz_axes_plane_name = 'xz_axes_plane';

export const plane_names = [
    xy_axes_plane_name,
    yz_axes_plane_name,
    xz_axes_plane_name,
] as const;

export type PlaneName = typeof plane_names[number];

export function is_coordinate_plane(x: Object3D): boolean {
    return plane_names.includes(x.name as any);
}
